@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <div
      fxlayout="row"
      fxLayoutAlign="space-between center">
      <div>
        <label class="upper">{{ displayName }}</label>
      </div>
    </div>
    @if (showFieldAsEdit) {
      <div>
        <ng-select
          [items]="documents"
          [(ngModel)]="selectedDocument"
          (ngModelChange)="onValueChanged()"
          bindLabel="_displayString"
          [multiple]="false"
          [minTermLength]="2"
          [placeholder]="placeholder"
          [loading]="documentsLoading"
          (search)="documentsInput$.next($event.term)"
        [clearable]="true"></ng-select>
      </div>
    }
    @if (!showFieldAsEdit) {
      <div
        style="display: block"
        >
        <div class="is-readonly">
          {{ selectedDocument._displayString }}
        </div>
      </div>
    }
  </div>
}
